/** Generated by the offline station-extents importer; do not edit manually. */
export const SUBWAY_STATION_EXTENTS_DATA_REVISION = '82ce5ad28926';
